import { memo, useCallback, useId, useState } from 'react';
import { Outlet, useMatch } from 'react-router';
import useAuth from '@/hooks/useAuth';
import { useClientQuery } from '@/hooks/useClientQuery';
import { useEntityConfig } from '@/hooks/useEntityConfig';
import OnboardingModal from '@/pages/Onboarding/OnboardingModal';
import { IbDeskGateway } from '@/providers/IbDeskGateway';
import { AppSidebar } from './AppSidebar';
import ProtectedSideHeader from './ProtectedSideHeader';
import Spinner from './Spinner';

const ProtectedLayout = memo(function ProtectedLayout() {
  const clientQuery = useClientQuery();
  const { client, onboardingModalOpen, setOnboardingModalOpen } = useAuth();
  const config = useEntityConfig();
  const isTradingIdeasPage = useMatch('/services/trading-ideas') !== null;
  const menuButtonId = useId();
  const [isMenuOpen, setMenuOpen] = useState(false);
  const openMenu = useCallback(() => setMenuOpen(true), []);
  const mainContentPaddingClass = isTradingIdeasPage ? 'p-0' : 'px-4 pt-3 pb-5 md:px-6';

  if (clientQuery.isLoading) {
    return <Spinner />;
  }

  const forceModal =
    (config.IS_SHOW_ONBOARDING_DEBUG_MODE || !!client?.client_details?.onboarding_steps?.length) && onboardingModalOpen;

  return (
    <IbDeskGateway currentClient={clientQuery.data}>
      <div className="flex min-h-svh w-full">
        <AppSidebar menuButtonId={menuButtonId} isMobileOpen={isMenuOpen} onMobileOpenChange={setMenuOpen} />

        <main className="relative flex min-w-0 flex-1 flex-col">
          <ProtectedSideHeader menuButtonId={menuButtonId} onMenuOpen={openMenu} />
          <div className={`${mainContentPaddingClass} flex flex-1 flex-col`}>
            <>
              <Outlet />
              {forceModal && (
                <OnboardingModal
                  clientQuery={clientQuery}
                  onboardingModalOpen={forceModal}
                  setOnboardingModalOpen={setOnboardingModalOpen}
                />
              )}
            </>
          </div>
        </main>
      </div>
    </IbDeskGateway>
  );
});

export default ProtectedLayout;
